module.exports = __webpack_public_path__ + "ag.no2.04341533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ag.no2.jpg
// module id = SPI8
// module chunks = 0